/**
 */
import createLogger from 'debug'
export const log = createLogger('module:log')
